/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable guard-for-in */
/* eslint-disable max-classes-per-file */
/* eslint-disable max-lines */
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { forkJoin, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import {
  AddProfileHeader,
  AddProfileDetail,
  AddTreatmentDetail,
  AddAeoDetail,
  setTabIndex,
  setProfileId,
  UpdateProfileHeader,
  UpdateTreatmentDetail,
  UpdateAeoDetail,
  AddRiskHeader,
  setInformationId,
  UpdateProfileDetail,
  getProfileHeader,
  UpdateRiskHeader,
  getRiskInfo,
  LoadSchema,
  LoadRdmRefValue,
  resetInformationId,
  UpdateSchedulerDetail,
  AddSchedulerDetail,
  LoadClassIndicators,
  resetRiskInfo,
  SetRiskStatus,
} from './ui-intelligencemgmt.actions';
import * as _ from 'lodash';
import { ProfileHeader, RiskHeader } from '../interface/ui-intelligencemgmt.interface';
import { ProfileManagementService } from '../services/profile-management.service';
import { RiskManagementTableService } from '../services/risk-management.service';
import { TargetGroupMockDataservice } from '../profile-managment/create-profile/details-tab/temp-target-group.service';
import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { RDMClientService } from 'src/app/shared-resources/services/rdm-client.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';
import { LoadBaseRdm } from 'src/app/shared-resources/store/base.action';
import { DateTimeService } from 'src/app/shared-resources/services/date-time.service';
import { RefValue } from 'src/app/shared-resources/interfaces/rdm-client.interface';
import { DateFormat } from 'src/app/shared-resources/interfaces/base-core-services.interface';
import { HttpErrorHandlerService, MessageType } from 'src/app/shared-resources/services/http-error-handling.service';

import { CommonRdmService } from 'src/app/layout/services/common-rdm.service';
import { BaseSharedState } from 'src/app/shared-resources/store/base.state';

export const rdmKeys = [
  'ums-all-contr-types',
  'umsmovement',
  'ics-treatment-treatmentType',
  'kc-favourite-list-master-data',
  'kc-favourite-list-status',
  'kc-declaration-prefix-transport',
  'kc-declaration-placeofloading',
  'kc-profile-treatment-department',
  'kc-profile-recommended-treatment',
  'kc-profile-treatment-recommended-actions',
  'ics-treatment-department',
  'ics-label-owner',
  'kc-profile-owner',
  'kc-profile-level',
  'ics-treatment-recommended-treatment',
  'ics-label-status',
  'kc-profile-risk-source-of-information',
  'kc-profile-status',
  'kc-risk-register-all-status',
  'kc-risk-register-status',
  'kc-profile-all-status',
  'kc-profile-risk-area',
  'ICS-AEO-legalform',
  'kc-profile-risk-name-of-the-department',
  'kc-profile-risk-name-of-the-ministry',
  'kc-profile-risk-severity',
  'kc-profile-risk-significance',
  'kc-profile-risk-priority',
  'ics-configuration-location-code',
  'ics-configuration-location-type',
  'kc-profile-category',
  'kc-profile-risk-area',
  'ics.risk.subject.method',
  "kc-profile-significance",
  'ics-label-aeo-risk-type',
  'nationality',
  'ics-label-country-code',
  'ics-label-port-type',
  'kc-profile-scheduler-frequency',
  'kc-profile-significance',
  'ics-label-valuation-status',
  'umscodes8213',
  'ics_passenger_trasportType',
  'tred3207',
  'ics-customs-office',
  'ics_passenger_inbound_outbound',
  'umscodes1001',
  'ics_passenger_declaration_docType',
  'ics_Passenger_PassengerType',
  "tred6345",
  "tred7007",
  "tred9213",
  "tred6311",
  "tred7065",
  "gender",
  "undg-class-name",
  "tred8249",
  "kc-profile-location-type",
  "kc-profile-location-name",
  "kc-profile-treatment-department",
  "ics-label-trader-city",
  "kc-profile-recommended-treatment",
  //CLM in rdm
  "Traders",
  "Customs Warehouse",
  "CustomsBroker",
  'kc-profile-approved-recommended-outcome',
  'kc-profile-rejected-recommended-outcome',
  'kc-profile-action-source',
  'kc-profile-actionable-field',
  'kc-profile-action-type',
  'kc-profile-risk-setting',
  'kc-declaration-cargotype-transport',
  'kc-declaration-attachments-certificatetype',
  'kc-declaration-containersize-containers',
  'kc-declaration-country',
  'kc-declaration-currency',
  'kc-declaration-customsoffice-generaldeclarationinformation',
  'kc-declaration-destinationregion',
  'kc-declaration-identification-warehouse',
  'kc-declaration-incoterm-deliveryterms',
  'kc-declaration-assessment-cdmethodofguarantee',
  'kc-declaration-methodofpayment',
  'kc-declaration-modeoftransport',
  'kc-declaration-modificationtype',
  'kc-declaration-nationalsubdivision-generaldeclarationinformation',
  'kc-declaration-notificationtype-notifications',
  'kc-declaration-procedurecode-generaldeclarationinformation',
  'kc-declaration-status-generaldeclarationinformation',
  'kc-declaration-taxtype',
  'kc-declaration-movements-transporttype',
  'kc-declaration-typeofpackages-packages',
  'kc-declaration-valuationmethod',
  'kc-dec-transport-cargo-type',
  'kc-dec-attach-certificate-type',
  'kc-dec-container-size',
  'kc-dec-country',
  'kc-dec-currency',
  'kc-dec-customs-office',
  'kc-dec-destination-region',
  'kc-dec-warehouse-id',
  'kc-dec-incoterm',
  'kc-dec-guarantee-method',
  'kc-dec-payment-method',
  'kc-dec-transport-mode',
  'kc-dec-modification-type',
  'kc-dec-national-subdivision',
  'kc-dec-notification-type',
  'kc-dec-procedure-code',
  'kc-dec-status',
  'kc-dec-tax-type',
  'kc-dec-transport-type',
  'kc-dec-package-type',
  'kc-dec-valuation-method',
  'kc-dec-declaration-type',
  'kc-profile-amend-reason',
  'kc-risk-amend-reason',
  
  'kc-dec-pay-protest-status',
  'kc-dec-pga-status',
  'kc-dec-payment-status',
  'kc-dec-first-subdivision',
  'kc-dec-trade-movement',
  // 'kc-dec-transport-prefix', //1000+ records
  // 'kc-dec-port-of-loading', //1000+ records
  'kc-dec-certificate-reference',
  'kc-dec-certificate-type',
  'kc-dec-type-of-taxtype',
  'kc-dec-modification-status',
  'kc-dec-valuation-status',
  'kc-profile-usage',
  'kc-fav-list-status'

  /*   'regimedecltypes',
  'ics-customs-office' */
];

// export interface TreatmentPayload {
//   treatmentId?: number;
//   type?: string;
//   treatmentType?: any[];
// }

export class CProfileStateModel {
  headerPayload: {} | any;
  detailPayload: {};
  treatmentPayload: {};
  // treatmentPayload: TreatmentPayload | null;
  schedulerPayload: {};
  aeoPayload: {};
  profileId: number | any;
  profileHeader: ProfileHeader[];
  riskInfo: RiskHeader | any;
  riskStatus: string;
  informationId: number | any;
  new_schema: {} | any;
  content: {};
  rdmData: {};
  schema: {} | any;
  dataType: {};
}

@Injectable()
@State<CProfileStateModel>({
  name: 'createProfile',
  defaults: {
    headerPayload: [],
    detailPayload: [],
    treatmentPayload: [],
    schedulerPayload: [],
    aeoPayload: [],
    content: [],
    profileId: null,
    profileHeader: [],
    riskInfo: null,
    informationId: null,
    riskStatus: 'Draft',
    rdmData: {},
    schema: null,
    new_schema: null,
    dataType: {},
  },
})
export class CreateProfileState {
  rdmMap: any = new Map();

  constructor(
    private profileMgtService: ProfileManagementService,
    private userInfoService: UserInfoService,
    private msg: NzMessageService,
    private rdmService: RDMClientService,
    private rdmData: RiskManagementTableService,
    private mockTargetGroup: TargetGroupMockDataservice,
    private notiService: NzNotificationService,
    private dateTimeService: DateTimeService,
    private httpMessage: HttpErrorHandlerService,
    private commonRdmService: CommonRdmService,
    private store: Store
  ) {}

  ngxsOnInit(context: StateContext<any>) {
    context.dispatch(new LoadSchema());
    context.dispatch(new LoadClassIndicators());
  }

  @Selector()
  static getSchema(state: any) {
    return state.schema;
  }

  @Selector()
  static getNewSchema(state: any) {
    return state.new_schema;
  }

  @Selector()
  static getProfileId(state: CProfileStateModel) {
    return state.profileId;
  }

  @Action(getProfileHeader)
  getProfileHeader(ctx: StateContext<CProfileStateModel>, { profileId }: getProfileHeader) {
    return this.profileMgtService.headerData(profileId).pipe(
      tap((result: any) => {
        ctx.patchState({
          profileHeader: result,
          headerPayload: [],
          detailPayload: [],
          schedulerPayload: [],
          // treatmentPayload: null,
          treatmentPayload: [],
          aeoPayload: [],
        });
      })
    );
  }

  @Selector()
  static getRdmList(state: any): RefValue[] {
    return state.content;
  }

  @Selector()
  static getRulesDataType(state: any): RefValue[] {
    return state.dataType;
  }

  @Selector()
  static getClassIndicators(state: any): any[] {
    return state.classIndicators;
  }

  @Selector()
  static getIndicators(state: any): any[] {
    return state.indicators;
  }

  // @Selector()
  // static getTreatmentPayload(state: CProfileStateModel) {
  //   return state.treatmentPayload;
  // }

  @Action(LoadSchema)
  LoadSchema(context: StateContext<any>) {
    this.mockTargetGroup.getTargetFieldData().subscribe((res: any) => {
      context.patchState({
        schema: res,
      });
    });
    this.mockTargetGroup.getDataType().subscribe((res: any) => {
      context.patchState({
        dataType: res,
      });
    });
    const schemaType = ['Declaration', 'Manifest', 'ExpressCourier'];
    const schemaTypeRequest: any[] = [];
    // schemaType.forEach((item) => {
    //  schemaTypeRequest.push(this.mockTargetGroup.getNewSchemaType(item));
    // });
    // return context.dispatch(new LoadRdmRefValue())
    // return forkJoin(schemaTypeRequest).pipe(
    //  tap((result: any) => {
    //    const newSchema = {
    //      ics: result[0] ? result[0] : undefined,
    //      ums: result[1] ? result[1] : undefined,
    //      expressCourier: result[2] ? result[2] : undefined,
    //    };
    //    context.patchState({
    //      new_schema: newSchema,
    //    });
    // context.dispatch(new LoadRdmRefValue());
    // })
    // );
  }

  @Action(LoadClassIndicators)
  LoadClassIndicators(context: StateContext<any>) {
    this.profileMgtService?.getProfileCategories().subscribe((response: any) => {
      if (response.statusCode == 200) {
        context.patchState({
          classIndicators: response.content,
        });

        context.dispatch(this.LoadIndicators(context, response.content));
      }
    });
  }

  // @Action(LoadClassIndicators)
  LoadIndicators(context: StateContext<any>, classIndicators: string[]) {
    if (!_.isEmpty(classIndicators)) {
      context.getState().classIndicators.forEach((category: string) => {
        this.profileMgtService?.getProfileIndicators(category).subscribe((response: any) => {
          let indicators = context.getState().indicators;
          if (!indicators) indicators = {};
          indicators[category] = response;
          context.patchState({
            indicators: indicators,
          });
        });
      });
    }
    context.dispatch(new LoadRdmRefValue());
  }

  strMapToObj(strMap: any) {
    const obj: any = Object.create(null);
    strMap.forEach((key: any, values: any) => {
      obj[values] = key;
    });
    return obj;
  }

  @Action(LoadRdmRefValue)
  GetRdmRefValue(context: StateContext<any>, action: LoadRdmRefValue) {
    const state = context.getState();
    const allTypes = [];
    const tarriffRdm: any = [];
    const productRdm = [];

    if (state.schema && state.schema.headerProfile) {
      for (const clazz in state.schema.headerProfile) {
        if (!_.isEmpty(state.schema.headerProfile[clazz]['refTypeCode'])) {
          allTypes.push(state.schema.headerProfile[clazz]['refTypeCode']);
        }
      }
    }

    if (state.new_schema) {
      for (const type in state.new_schema) {
        if (type != 'ics') {
          for (const clazz in state.new_schema[type]) {
            for (const field in state.new_schema[type][clazz]) {
              if (!_.isEmpty(state.new_schema[type][clazz][field]['refTypeCode'])) {
                const rdmReftypes = state.new_schema[type][clazz][field]['refTypeCode'].split(',');
                rdmReftypes.forEach((refType: any) => {
                  if (!this.rdmMap.has(refType)) {
                    allTypes.push(refType);
                  }
                });
              }
            }
          }
        }
      }
    }

    this.rdmData.tarriffRdmData().subscribe((tarriffResult: any) => {
      tarriffResult.content.forEach((element: any) => {
        const dataTarriff = { label: element, code: element };
        tarriffRdm.push(dataTarriff);
        this.rdmMap.set('tariff', tarriffRdm);
        context.patchState({
          content: this.strMapToObj(this.rdmMap),
        });
      });
    });

    this.rdmData.productRdmData().subscribe((productResult: any) => {
      productResult.productSearchDto?.content.forEach((element: any) => {
        const dataProduct = {
          label: element.productEngShortDesc + '-' + element.productCode,
        };
        productRdm.push(dataProduct);
        this.rdmMap.set('productCode', dataProduct);
        context.patchState({
          content: this.strMapToObj(this.rdmMap),
        });
      });
    });

    // Only dispatch keys that are not already in the store
    const storeRdm: Map<string, any> = this.store.selectSnapshot(BaseSharedState.getRdmData) || new Map();
    const combinedKeys = _.uniq(_.concat(allTypes, rdmKeys));
    const missingKeys = combinedKeys.filter(key => !storeRdm.has(key));

    if (missingKeys.length > 0) {
      context.dispatch(new LoadBaseRdm(missingKeys, 'intelligencemgmt'));
    }
  }

  @Action(AddProfileHeader)
  AddProfileHeader(ctx: StateContext<CProfileStateModel>, { payload, operationType }: AddProfileHeader) {
    const state = ctx.getState();

    if (_.isEqual(state.headerPayload, payload) == true) {
      ++this.profileMgtService.selectedIndex;
      return of(null);
    } else if (state.headerPayload['profileCode'] == payload.profileCode) {
      return ctx.dispatch(new UpdateProfileHeader(payload, state.profileId, operationType));
    } else {
      const user = this.userInfoService.getUserName ? this.userInfoService.getUserName() : 'Anonymous';
      return this.profileMgtService.postRiskProfileHeader(payload, user).pipe(
        tap((result: any) => {
          if (result.statusCode == 201) {
            this.notiService.success('Success', 'Profile Header saved successfully.');
            ctx.patchState({
              headerPayload: payload,
              profileId: result.content.profileId,
            });
            ++this.profileMgtService.selectedIndex;
          } else {
            result.errorMessage.forEach((element: any) => {
              this.notiService.error('Error', element.detailErrorMessage);
            });
          }
        })
      );
    }
  }

  @Action(UpdateProfileHeader)
  UpdateProfileHeader({ getState, patchState }: StateContext<CProfileStateModel>, { payload, profileId, operationType = '', isDraft }: UpdateProfileHeader) {
    const state = getState();
    
    // Always make API call for draft saves or when operationType is 'amend'
    if (_.isEqual(state.headerPayload, payload) == true && !isDraft && operationType !== 'amend') {
      ++this.profileMgtService.selectedIndex;
      return of(null); // Return observable for consistency
    } else {
      let user = this.userInfoService.getUserName ? this.userInfoService.getUserName() : 'Anonymous';
      return this.profileMgtService.updateRiskProfileHeader(payload, profileId, operationType, user).pipe(
        tap((result: any) => {
          if (result.statusCode == 201 || result.statusCode == 200) {
            this.notiService.success('Success', 'Profile Header saved successfully.');
            patchState({
              headerPayload: payload,
              profileId: result.content.profileId,
            });
            if (!isDraft) {
              ++this.profileMgtService.selectedIndex;
            }
          } else {
            result.errorMessage.forEach((element: any) => {
              this.notiService.error('Error', element.detailErrorMessage);
            });
          }
        })
      );
    }
  }

  @Action(AddProfileDetail)
  AddProfileDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid }: AddProfileDetail) {
    // eslint-disable-next-line no-unused-vars
    const state: any = getState();
    // if ((_.isEqual(state.detailPayload, payload)) == true) {
    //     ++this.profileMgtService.selectedIndex;
    //     return;
    // }
    // else {
    return this.profileMgtService.postRiskProfileDetails(payload, pid).pipe(
      tap((result: any) => {
        if (result.statusCode == 201) {
          this.notiService.success('Success', 'Profile Rules saved successfully');
          patchState({
            detailPayload: payload,
          });
          ++this.profileMgtService.selectedIndex;
        } else {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.detailErrorMessage);
          });
        }
      })
    );
    // }
  }

  @Action(UpdateProfileDetail)
  UpdateProfileDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid, operationType }: UpdateProfileDetail) {
    return this.profileMgtService.updateRiskProfileDetails(payload, pid, operationType).pipe(
      tap((result: any) => {
        if (result.statusCode == 200) {
          this.notiService.success('Success', 'Profile Rules saved successfully');
          patchState({
            detailPayload: payload,
          });
          ++this.profileMgtService.selectedIndex;
        } else {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.detailErrorMessage);
          });
        }
      })
    );
  }

  @Action(AddTreatmentDetail)
  AddTreatmentDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid }: AddTreatmentDetail) {
    const user = this.userInfoService.getUserName ? this.userInfoService.getUserName() : 'Anonymous';
    return this.profileMgtService.postRiskProfileTreatment(payload, pid, user).pipe(
      tap((result: any) => {
        if (result?.statusCode == 201) {
          this.notiService.success('Success', 'Profile Treatment saved successfully');
          patchState({
            treatmentPayload: payload,
          });
          if (this.profileMgtService.disableSchedule) {
            this.profileMgtService.selectedIndex = this.profileMgtService.selectedIndex + 2;
          } else {
            ++this.profileMgtService.selectedIndex;
          }
        } else {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.detailErrorMessage);
          });
        }
      })
    );
  }

  @Action(UpdateTreatmentDetail)
  UpdateTreatmentDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid, operationType }: UpdateTreatmentDetail) {
    return this.profileMgtService.updateRiskProfileTreatment(payload, pid, operationType).pipe(
      tap((result: any) => {
        if (result?.statusCode == 200) {
          this.notiService.success('Success', 'Profile Treatment saved successfully');
          patchState({
            treatmentPayload: payload,
          });
          if (this.profileMgtService.disableSchedule) {
            this.profileMgtService.selectedIndex = this.profileMgtService.selectedIndex + 2;
          } else {
            ++this.profileMgtService.selectedIndex;
          }
        } else {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.detailErrorMessage);
          });
        }
      })
    );
  }

  @Action(AddSchedulerDetail)
  AddSchedulerDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid }: AddSchedulerDetail) {
    if (payload.startTime != null) {
      payload.startTime = this.dateTimeService.getTimeFormat(payload.startTime, DateFormat.HH_mm);
    }
    if (payload.endTime != null) {
      payload.endTime = this.dateTimeService.getTimeFormat(payload.endTime, DateFormat.HH_mm);
    }
    const user = this.userInfoService.getUserName ? this.userInfoService.getUserName() : 'Anonymous';
    return this.profileMgtService.postRiskProfileSchedule(payload, pid, user).pipe(
      tap((result: any) => {
        if (result.statusCode == 200) {
          this.notiService.success('Success', 'Profile Scheduler saved successfully');
          patchState({
            schedulerPayload: payload,
          });
          ++this.profileMgtService.selectedIndex;
        } else {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.detailErrorMessage);
          });
        }
      })
    );
  }

  @Action(UpdateSchedulerDetail)
  UpdateSchedulerDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid, operationType }: UpdateSchedulerDetail) {
    if (payload.startTime != null) {
      payload.startTime = this.dateTimeService.getTimeFormat(payload.startTime, DateFormat.HH_mm);
    }
    if (payload.endTime != null) {
      payload.endTime = this.dateTimeService.getTimeFormat(payload.endTime, DateFormat.HH_mm);
    }
    const user = this.userInfoService.getUserName ? this.userInfoService.getUserName() : 'Anonymous';
    return this.profileMgtService.postRiskProfileSchedule(payload, pid, user).pipe(
      tap((result: any) => {
        if (result.statusCode == 200) {
          this.notiService.success('Success', 'Profile Scheduler saved successfully');
          patchState({
            schedulerPayload: payload,
          });
          ++this.profileMgtService.selectedIndex;
        } else {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.detailErrorMessage);
          });
        }
      })
    );
  }

  @Action(AddAeoDetail)
  AddAeoDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid, save }: AddAeoDetail) {
    // eslint-disable-next-line no-unused-vars
    const state: any = getState();
    const userName = this.userInfoService.getUserName ? this.userInfoService.getUserName() : 'Anonymous';
    return this.profileMgtService.postRiskProfileAEO(payload, pid, userName, save).pipe(
      catchError((error) => of(error)),
      tap((result: any) => {
        if (result.statusCode == 201) {
          if (save) {
            this.notiService.success('Success', "Profile's AEO details saved successfully");
          } else {
            this.notiService.success('Success', 'Profile details submitted successfully');
          }
          patchState({
            aeoPayload: payload,
          });
        } else {
        if (result?.error?.errorMessage && Array.isArray(result?.error?.errorMessage)) {
            const errorMessages = result?.error?.errorMessage.map((err: any) => err.errorMessage || err.detailErrorMessage).filter(Boolean);
            if (errorMessages.length > 0) {
            this.notiService.error('',errorMessages.join('\n'))
            } else {
              this.notiService.error('','An error occurred while processing your request.');
            }
          } else if (result?.error?.message) {
            this.notiService.error('','error?.message');
          } else {
            this.notiService.error('', 'An error occurred while processing your request.');
          }
        }
      })
    );
  }
  @Action(UpdateAeoDetail)
  UpdateAeoDetail({ getState, patchState }: StateContext<CProfileStateModel>, { payload, pid, operationType, save }: UpdateAeoDetail) {
    const state: any = getState();
    const userName = this.userInfoService.getUserName ? this.userInfoService.getUserName() : 'Anonymous';
    return this.profileMgtService.updateRiskProfileAEO(payload, pid, userName, operationType, save).pipe(
      tap((result: any) => {
        if (result.statusCode == 200) {
          if (save) {
            this.notiService.success('Success',"Profile's AEO details saved successfully");
          } else {
            const msg = operationType == 'amend' ? 'Amended Risk Profile submitted successfully for Supervisor Review' : 'Profile details submitted successfully'
            this.notiService.success('Success', msg);
          }
          patchState({
            aeoPayload: payload,
          });
        } else if (result.statusCode == 400) {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.errorMessage);
          });
        }
      })
    );
  }

  @Action(setTabIndex)
  setTabIndex({ getState, patchState }: StateContext<CProfileStateModel>, { payload }: setTabIndex) {
    const state = getState();
    // state.selectedTab = payload;
  }

  @Action(setProfileId)
  setProfileId({ getState, patchState }: StateContext<CProfileStateModel>, { payload }: setProfileId) {
    patchState({
      profileId: payload,
    });
  }

  @Selector()
  static getInformationId(state: CProfileStateModel) {
    return state.informationId;
  }

  @Selector()
  static getRiskStatus(state: CProfileStateModel) {
    return state.riskStatus;
  }

  @Selector()
  static riskInfoDetail(state: CProfileStateModel) {
    return state.riskInfo;
  }

  @Action(resetInformationId)
  resetInformationId({ getState, patchState }: StateContext<CProfileStateModel>) {
    const state = getState();
    patchState({
      informationId: null,
      riskStatus: 'Draft',
    });
  }

  @Action(AddRiskHeader)
  AddRiskHeader({ getState, patchState }: StateContext<CProfileStateModel>, { payload, optype }: AddRiskHeader) {
    return this.profileMgtService.postCreateRiskHeader(payload, optype, 'Risk Analyst').pipe(
      tap((result: any) => {
        const state = getState();
        if (result.statusCode == 200) {
          this.afterRiskSubmitCreate(payload, result, patchState);
        } else if (result.statusCode == 400) {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.errorMessage);
          });
        }
      })
    );
  }

  @Action(UpdateRiskHeader)
  UpdateRiskHeader({ getState, patchState }: StateContext<CProfileStateModel>, { payload, optype, Id }: UpdateRiskHeader) {
    return this.profileMgtService.updateRiskinfoHeader(payload, Id, 'Risk Analyst').pipe(
      tap((result: any) => {
        const state = getState();
        if (result.statusCode == 200) {
          this.afterRiskSubmitCreate(payload, result, patchState)
        } else if (result.statusCode == 400) {
          result.errorMessage.forEach((element: any) => {
            this.notiService.error('Error', element.errorMessage);
          });
        }
      })
    );
  }

  @Action(getRiskInfo)
  getRiskInfo(ctx: StateContext<CProfileStateModel>, { riskId }: getRiskInfo) {
    return this.profileMgtService.getRiskDetail(riskId).pipe(
      tap((result: any) => {
        ctx.patchState({
          riskInfo: result.content,
          informationId: result.content.riskInformationId,
        });

        console.log({ ctx });
      })
    );
  }

  @Action(resetRiskInfo)
resetRiskInfo(ctx: StateContext<CProfileStateModel>) {
  ctx.patchState({
    riskInfo: null
  });
}


  @Action(setInformationId)
  setInformationId({ getState, patchState }: StateContext<CProfileStateModel>, { payload }: setInformationId) {
    return this.profileMgtService.recomendedOutcome(payload).pipe(
      tap((result: any) => {
        const state = getState();
        if (result.statusCode == 200) {
          // this.msg.success("Header Submitted Succesfully...");
          patchState({
            informationId: payload,
          });
          // ++this.profileMgtService.selectedIndex;
        } else if (result.statusCode == 400) {
          result.errorMessage.forEach((item: any) => {
            this.msg.error(item.errorMessage);
          });
        }
      })
    );
  }

  @Action(SetRiskStatus)
  SetRiskStatus({ getState, patchState }: StateContext<CProfileStateModel>, { status }: SetRiskStatus) {
    patchState({
      riskStatus: status,
    });
  }

  afterRiskSubmitCreate(payload:any, result:any, patchState:any) {
    const message = payload.status === 'Draft'  ? 'Risk information changes saved successfully' : 
    payload.status.toLowerCase() == 'pending_amendment' ? 'Amended Risk Register submitted successfully for Supervisor Review' 
    : 'Risk information changes submitted successfully';
    this.notiService.success('', message);
    patchState({
      informationId: result.content.riskInformationId,
      riskStatus: result.content.status,
      riskInfo: result.content,
    });
  }
}
